import { Link } from "react-router-dom";
import SeoLayout from "@/components/SeoLayout";
import { SeoMeta } from "@/components/Jsonld";
import BookingWizard from "@/components/BookingWizard";
import { Rocket } from "lucide-react";

export default function Book() {
  return (
    <SeoLayout>
      <SeoMeta title="Book Appliance Repair · Same-Day in San Antonio · Space Appliance" description="Book same-day appliance repair in San Antonio in 60 seconds. Use code GRAND_OPENING for $10 off your first repair." />
      <section className="max-w-2xl mx-auto px-5 sm:px-8 py-14">
        <div className="text-center">
          <div className="chip"><Rocket className="w-3.5 h-3.5" /> Mission Control · Booking</div>
          <h1 className="display-retro mt-5 text-cream text-4xl sm:text-5xl normal-case font-semibold leading-[1.05]">
            Book <span className="text-orange">appointment</span><span className="text-gold">.</span>
          </h1>
          <p className="mt-4 text-cream/75 max-w-xl mx-auto">
            60 seconds. A dispatcher confirms your window in under 30 minutes.
            Code <span className="text-gold font-semibold tracking-widest">GRAND_OPENING</span> saves you $10.
          </p>
        </div>
        <div className="mt-10">
          <BookingWizard variant="embed" />
        </div>
        <div className="mt-10 text-center text-xs label-retro text-cream/50 uppercase tracking-widest">
          Already booked? <Link to="/track" className="text-orange hover:text-orange-2" data-testid="book-go-track">Track your repair →</Link>
        </div>
      </section>
    </SeoLayout>
  );
}
